// @ts-nocheck
/** Matchmaking queue tips, grouped by category (picked at random while searching). */
export const MM_QUEUE_TIPS = {
  tips: [
    "Synergy skills: Buy a synergy node on one spell and own its partner spell to unlock alternate behavior — browse them in the Spellbook.",
    "Did you know: You can learn about each skill in the spellbook while you're in the queue!",
    "Did you know: You can search while in the spellbook or spell shop by typing.",
    "Did you know: You can move skills on the action bar — hold Shift and drag a skill to another slot.",
    "Do not enter the void — It hurts...",
    "Avoid the nuclear shockwave from the Nuke skill by hiding behind obstacles — try Glacier.",
    "Knockback comes from damage — wounded wizards fly farther, so finish low-health rivals with a well-aimed shove.",
    "Pillars and ice walls block projectiles and shockwaves — use them to your advantage.",
  ],
  funny: [
    "Avoid the void… Pun intended.",
    "There is no cow level…",
    "It's not lag — you just got launched into another timezone.",
    "You miss 100% of the fireballs you don't cast.",
    "If you're reading this, you're not in the void. Yet.",
  ],
};

export function pickMmQueueTip(last = "") {
  const pool = MM_QUEUE_TIPS.tips.concat(MM_QUEUE_TIPS.funny);
  if (!pool.length) return "";
  if (pool.length === 1) return pool[0];
  let tip;
  do { tip = pool[Math.floor(Math.random() * pool.length)]; } while (tip === last);
  return tip;
}

/** How long each tip toast stays on screen (ms). */
export const MM_QUEUE_TIP_MS = { min: 12000, max: 18000, gap: 400 };
